<template>
    <b-container>
        <div v-if="screen==='welcome'" class="welcome">
            <b-row>
                <b-col class="text-center">
                    <img src="./images/ship.png" class="logo img-fluid"/>
                </b-col>
            </b-row>
            <b-row class="justify-content-md-center">
                <b-col md="7" lg="5">
                    <h2>Welcome</h2>
                    <p></p>
                    <b-form-group label="Passenger ID:" label-for="passengerId" description="If you do not have your Passenger ID please contact automated services.">
                        <b-form-input id="passengerId" v-model="passengerId"></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="primary" class="float-right" @click="checkId">Access</b-button>
                    <div class="idError" v-if="idError">Invalid ID.</div>
                </b-col>
            </b-row>
        </div>

        <div v-else-if="screen==='services'" class="services">
            <b-row>
                <b-col class="text-center">
                    <img src="./images/ship.png" class="logo img-fluid"/>

                    <div class="content">
                        <h2>Ship Services</h2>
                        <p>Welcome to the {{config.settings.ship}}. We hope you enjoy your stay. All of our automated services are at your service.</p>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" sm="6">
                    <b-button block variant="primary" @click="error=true">Food & Beverage</b-button>
                    <b-button block variant="primary" @click="error=true">Climate Control</b-button>
                    <b-button block variant="primary" @click="error=true">Entertainment</b-button>
                </b-col>
                <b-col cols="12" sm="6">
                    <b-button block variant="primary" @click="error=true">Fun & Games</b-button>
                    <b-button block variant="primary" @click="error=true">Ship Map</b-button>
                    <b-button block variant="primary" @click="error=true">Passenger Directory</b-button>
                </b-col>
            </b-row>
            <b-row v-if="passengerId.toLowerCase()==='mt29842'">
                <b-col cols="12">
                    <hr/>
                    <b-button block variant="warning" @click="screen='log'">Maintenance Log</b-button>
                    <b-button block variant="warning" @click="login=true">Ship Systems</b-button>
                </b-col>
            </b-row>
            <hr/>
            <b-row>
                <b-col cols="12">
                    <b-button block variant="light" @click="passengerId='';screen='welcome'">Logout</b-button>
                </b-col>
            </b-row>
            <hr/>
        </div>

        <div v-if="screen==='log'" class="calendar">
            <b-row>
                <b-col>
                    <h2>Maintenance Log</h2>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="screen='services'" class="float-right">Back</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h3>WARNING: current date error detected</h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead class="thead-default">
                            <tr>
                                <th colspan="1" @click="previousMonth" class="clickable">
                                    «
                                </th>
                                <th colspan="5" class="center-title">
                                    {{currentMonthAndYear}}
                                </th>
                                <th colspan="1" @click="nextMonth" class="clickable">
                                    »
                                </th>
                            </tr>
                            <tr>
                                <th>M</th>
                                <th>T</th>
                                <th>W</th>
                                <th>T</th>
                                <th>F</th>
                                <th>S</th>
                                <th>S</th>
                            </tr>
                            </thead>
                            <tbody class="tbody-default" data-bind="foreach:gridArray">
                            <tr v-for="item in gridArray">
                                <td v-for="data in item" @click="setDate(data)" class="clickable">
                                    {{data.getDate()}}
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                    <transition name="fade">
                        <div class="alert alert-success" v-if="filterDate != undefined">{{logEntry}}</div>
                    </transition>
                </b-col>
            </b-row>
        </div>

        <div class="error" v-if="error">
            <div class="align-middle">
                <h3>ERROR</h3>
                <p>An internal malfunction occurred. The selected service is currently unavailable.</p>
                <b-button variant="danger" block @click="error=false">Bummer!</b-button>
            </div>
        </div>

        <div class="login" v-if="login">
            <h3>AUTHORIZED PERSONNEL ONLY</h3>
            <p>What is the access password?</p>

            <b-form-input id="accessPassword" v-model="accessPassword"></b-form-input>

            <b-button block variant="light" @click="checkLogin">Login</b-button>
            <b-button block @click="login=false">Cancel</b-button>
        </div>

        <div v-if="screen==='system'" class="system">

            <div class="warning-message">
                <h2>..//systEM MALfunctiONNN</h2>
                <h4>WARNING: manual____ config processing only. </h4>
            </div>

            <div class="manual">
                <span>System Config Number (4 Digit)</span>
                <b-form-input id="manualCode" v-model="manualCode"></b-form-input>
            </div>

            <div class="override" v-if="override">
                <h2>SELF DESTRUCT OVERRIDE</h2>

                <div>
                    OVERRIDE CODE 1 &nbsp; ({{config.puzzles[0].answer.length}} Characters)
                    <b-form-input type="text" v-model="codes.one"></b-form-input>
                </div>
                <div>
                    OVERRIDE CODE 2 &nbsp; ({{config.puzzles[1].answer.length}} Characters)
                    <b-form-input type="text" v-model="codes.two"></b-form-input>
                </div>
                <div>
                    OVERRIDE CODE 3 &nbsp; ({{config.puzzles[2].answer.length}} Characters)
                    <b-form-input type="text" v-model="codes.three"></b-form-input>
                </div>
                <b-button block variant="light" @click="checkOverride">Submit</b-button>
            </div>

            <div class="repair">
                <ul>
                    <li v-for="attempt in attempts">{{attempt}}</li>
                </ul>
            </div>
        </div>

        <div v-if="screen==='deactivated'" class="deactivated">
            <div class="warning-message">
                <h1>DEACTIVATED</h1>
                <h2>SELF DESTRUCT SEQUENCE</h2>
            </div>

            <img class="party blink_me" src="./images/party.png" />
        </div>

    </b-container>
</template>

<script>
    import moment from 'moment';

    let commandStart = ['Attempting to access ship diagnostics ',
            'Re-aligning support vectors ',
            'Analyzing damage data ',
            'Sending Distress Signal ',
            'Dispatching Repair Modules ',
            'fus -33 -n ',
            'wget -a -t ',
            'tar -xzf ',
            'Calculating distance ',
            'Compilation Started of ',
            'Adjusting Climate Controls '];

    let commandParts = ['',
            'Jefferies tube 20...',
            '',
            'TPS Reports',
            'Analyzing...',
            '2.44.322.2',
            'Subnet 298.2',
            'Reacting///',
            'AI recalibrating...',
            'false',
            '33**2'
    ];

    let commandResponses = ['Authorizing ',
            'DATA MATRIX SCRAMBLED!',
            'Access Granted...',
            'WARNING: Unable to access proper system entry point',
            'Compression Complete.',
            'Compilation of Data Structures Complete..',
            'Entering Security Console...',
            'Encryption Unsuccessful Attempting Retry...',
            'MALFUNCTION!',
            'DATA IS CORRUPT!',
            'SELF DESTRUCT!'];

    export default {
        name: 'Kit1Interact',
        props: ['message','code','config'],
        data: function () {
            return {
                timeout: null,
                screen: 'welcome',
                error: null,
                login: null,
                passengerId: null,
                idError: false,
                accessPassword: '',
                codes: {
                    one: '',
                    two: '',
                    three: ''
                },
                override: false,
                attempts: [],
                manualCode: '',

                filterDate: undefined,
                selectedDate: moment('2142-10-01').toDate(),
                currentMonthAndYear: 'Oct 2142',
                logEntry: 'No log entries found.'
            }
        },
        methods: {
            next: function() {
                this.timeout = setTimeout(this.step.bind(this), 500);
            },
            step: function() {
                if (this.screen === 'system') {
                    this.attempts.push(commandStart[getRand()] + ' ' + commandParts[getRand()] + ' ' + commandResponses[getRand()]);
                    if (this.attempts.length > 100) {
                        this.attempts.shift()
                    }
                    this.next();
                }
            },
            checkId: function() {
                if (/^LX\d{5}$/i.test(this.passengerId) || this.passengerId.toLowerCase()==='mt29842') {
                    this.idError = false;
                    this.screen = 'services';
                } else {
                    this.idError = true;
                    let self = this;
                    setTimeout(function() {
                        self.idError = false;
                    }, 3000);
                }
            },
            checkLogin: function() {
                if (this.accessPassword.toLowerCase() === '2little2late') {
                    this.login = false;
                    this.screen = 'system';
                    this.next();
                }
            },
            checkOverride: function() {
                if (this.codes.one.toLowerCase() === this.config.puzzles[0].answer &&
                    this.codes.two.toLowerCase() === this.config.puzzles[1].answer &&
                    this.codes.three.toLowerCase() === this.config.puzzles[2].answer) {
                        this.$socket.sendObj({
                            cmd: 'broadcast',
                            data: {
                                room: this.code,
                                message: {
                                    cmd: 'play',
                                    data: {
                                        sound: 'deactivated'
                                    }
                                }
                            },
                            identity: this.$store.state.socket.identity
                        });
                        this.screen = 'deactivated';
                }
            },

            previousMonth: function() {
                let tmpDate = this.selectedDate;
                let tmpMonth = tmpDate.getMonth() - 1;
                this.selectedDate = new Date(tmpDate.setMonth(tmpMonth));
                this.currentMonthAndYear = moment(this.selectedDate).format('MMM YYYY');
            },
            nextMonth: function() {
                let tmpDate = this.selectedDate;
                let tmpMonth = tmpDate.getMonth() + 1;
                this.selectedDate = new Date(tmpDate.setMonth(tmpMonth));
                this.currentMonthAndYear = moment(this.selectedDate).format('MMM YYYY');
            },
            setDate: function(date) {
                if (date == this.filterDate) {
                    console.log('setting undefined');
                    this.filterDate = undefined;
                    //unselected
                } else {
                    this.filterDate = date;

                    this.logEntry = 'No log entries found for ' + moment(date).format('dddd, MMMM Do YYYY');

                    if (date.getFullYear()===2144 && date.getMonth()===11 && date.getDate()===13) {
                        this.logEntry = this.config.puzzles[3].answer;
                    }
                }
            },
            isActive: function(date) {
                return date === this.filterDate;
            },
            getCalendarMatrix: function(date) {
                let calendarMatrix = [];

                let startDay = new Date(date.getFullYear(), date.getMonth(), 1);
                let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

                // Modify the result of getDay so that we treat Monday = 0 instead of Sunday = 0
                let startDow = (startDay.getDay() + 6) % 7;
                let endDow = (lastDay.getDay() + 6) % 7;

                // If the month didn't start on a Monday, start from the last Monday of the previous month
                startDay.setDate(startDay.getDate() - startDow);

                // If the month didn't end on a Sunday, end on the following Sunday in the next month
                lastDay.setDate(lastDay.getDate() + (6 - endDow));

                let week = [];
                while (startDay <= lastDay) {
                    week.push(new Date(startDay));
                    if (week.length === 7) {
                        calendarMatrix.push(week);
                        week = []
                    }
                    startDay.setDate(startDay.getDate() + 1)
                }

                return calendarMatrix;
            }
        },
        computed: {
            gridArray: function () {
                return this.getCalendarMatrix(this.selectedDate);
            },
            formattedDate: function () {
                return this.filterDate ? moment(this.filterDate).format('lll') : '';
            }
        },
        watch: {
            manualCode: function(newValue) {
                if (newValue.length === 4) {
                    if (this.manualCode === this.config.puzzles[4].answer) {
                        this.override = true;
                    }
                    this.manualCode = '';
                }
            }
        },
        created: function() {

        }
    }

    function getRand() {
        return Math.floor(Math.random() * 10);
    }
</script>

<style lang="scss" scoped>
    .welcome {
        padding-top: 20px;
        .logo {
            padding: 20px 0;
            max-width: 250px;
        }

        .idError {
            color: red;
        }
    }

    .services {
        .content {
            p {
                font-size: 14px;
            }

            .nav {
                list-style: none;

                li {
                    display: block;
                }
            }
        }

        .system-link {
            position: fixed;
            bottom: 50px;
            right: 50px;

            a {
                text-decoration: none;
                color: #707070;
                font-size: 14px;
            }
        }
    }

    .calendar {
        margin-top: 20px;

        h3 {
            background: white;
            color: red;
            margin: 0;
            display: inline-block;
            font-size: 1em;
        }

        .clickable {
            color: #4180EE;
            font-size: 1.2em;
        }

        th, td {
            width: 14.285714285714286%;
            text-align: center;
        }
    }

    .error {
        position: fixed;
        bottom: 20px;
        left: 20px;
        right: 20px;
        border: 5px solid red;
        background: rgba(0,0,0,1);
        text-align: center;
        color: red;
        padding: 10px;

        .btn {
            background-color: red;
        }
    }

    .login {
        position: fixed;
        bottom: 20px;
        left: 20px;
        right: 20px;
        max-width: 500px;
        border: 5px solid red;
        background: rgba(0,0,0,1);
        text-align: center;
        color: red;
        padding: 10px;

        h3 {
            margin-bottom: 15px;
        }

        input {
            border: 1px solid white;
            padding: 10px;
            margin-top: 10px;
            font-size: 18px;
            border-radius: 0;
            color: black;
        }
    }

    .system {

        color: #00FF00;
        font-size: 13px;

        .warning-message {
            position: absolute;

            h2 {
                border: 2px solid white;
                color: red;
                font-size: 3em;
                margin: 30px 0 0 0;
            }

            h4 {
                background-color: white;
                color: red;
                display: inline-block;
                font-size: 1.5em;
            }

            top: 0;
            left: 0;
            z-index: 1000;
        }

        .manual {
            position: fixed;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1000;

            span {
                background: white;
                color: red;
                font-weight: bold;
                font-size: 16px;
            }

            input {
                background: black;
                border-radius: 0;
                color: white;
            }
        }

        .override {
            position: fixed;
            right: 0;
            left: 0;
            bottom: 0;
            padding: 20px;
            color: white;
            background: red;
            z-index: 1001;
            max-width: 500px;

            h2 {
                margin: 0 0 10px;
            }

            input {
                display: block;
                border: 1px solid white;
                border-radius: 0;
                background-color: black;
                color: white;
                padding: 8px;
                font-size: 16px;
                margin: 5px 0 10px 0;
            }
        }

        .repair {
            position: fixed;
            overflow: hidden;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            ul {
                position: absolute;
                bottom: 80px;
            }
        }
    }

    .deactivated {
        .warning-message {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            text-align: center;

            h1 {
                font-size: 2em;
                letter-spacing: 5px;
                background: green;
                color: black;
                margin-top: 50px;
                padding: 30px;
            }

            h2 {
                font-size: 20px;
                letter-spacing: 10px;
                background: white;
                color: black;
                margin-top: 50px;
                padding: 15px;
            }

            z-index: 1000;
        }

        .party {
            position: absolute;
            margin: auto;
            bottom: 100px;
            left: 0;
            right: 0;
            width: 50px;
        }

        .blink_me {
            animation: blinker 1.5s linear infinite;
        }

        @keyframes blinker {
            50% {
                opacity: 0;
            }
        }
    }

    .btn-block {
        margin-top: .5rem;
    }

</style>


// WEBPACK FOOTER //
// src/kits/1/interact.vue